package io.horion.cv.di

import io.horion.cv.api.repository.cv.CvRepository
import io.horion.cv.api.repository.cv.CvRepositoryImpl
import io.horion.cv.api.repository.job.JobRepository
import io.horion.cv.api.repository.job.JobRepositoryImpl
import io.horion.cv.api.repository.letter.LetterRepository
import io.horion.cv.api.repository.letter.LetterRepositoryImpl
import io.horion.cv.api.repository.payement.PayRepository
import io.horion.cv.api.repository.payement.PayRepositoryImpl
import org.koin.dsl.module

val repositoryModule = module {
    single<CvRepository> { CvRepositoryImpl() }
    single<LetterRepository> { LetterRepositoryImpl() }
    single<JobRepository> { JobRepositoryImpl() }
    single<PayRepository> { PayRepositoryImpl() }
}